import { getDownloadURL, getStorage, ref } from "firebase/storage";
import React, { useEffect, useState } from 'react';
import { isNullOrEmpty } from '../helper/helper';

type AvatarProps = {
    style?: React.CSSProperties,
    uri?: string,
    firstname: string,
    lastname: string,
}

// { width = "40px", height = "40px"}

function Avatar({ style, uri, firstname, lastname }: AvatarProps) {

    const [imageUrl, setImageUrl] = useState<string | undefined>();

    const gstorage = getStorage()

    useEffect(() => {
        if (uri?.startsWith('gs://')) {
            const fetchImageUrl = async () => {
                try {
                    const imgRef = ref(gstorage, uri)
                    const url = await getDownloadURL(imgRef);
                    setImageUrl(url);
                } catch (error) {
                    console.log('Error getting image URL:', error);
                }
            };
            fetchImageUrl();
        } else {
            setImageUrl(isNullOrEmpty(uri) ? undefined : uri)
        }
        // eslint-disable-next-line
    }, [uri]);


    if (imageUrl) {
        return <div style={{ display: "inline-block", verticalAlign: "middle" }}><img alt="avatar" style={{ ...style, borderRadius: "50%" }} src={imageUrl}>
        </img></div>
    } else {
        return <div style={{
            ...style,
            backgroundColor: "#006166",
            display: "inline-block", verticalAlign: "middle", textAlign: "center", borderRadius: "50%"
        }}>
            <div style={{ transform: "translateY(-50%)", color: "white", position: "relative", top: "50%", }}>{firstname?.charAt(0)}{lastname?.charAt(0)}</div>
        </div>
    }
}

export default Avatar